const prefix = 'control-tower-attendance:';
const validId = (value) => Number.isSafeInteger(value) && value > 0;
const validKey = (value) => typeof value === 'string' && /^[a-f\d-]{36}$/i.test(value);

export function attendancePath(path, record) {
  if (!record) return path;
  const url = new URL(path, window.location.origin);
  if (url.origin !== window.location.origin) throw new Error('Destino de atendimento inválido.');
  url.searchParams.set('tc', record.operationId);
  return `${url.pathname}${url.search}`;
}

/**
 * Estado de navegação para a volta ao Kanban: reabre o modal Veículos disponíveis da mesma carga,
 * com raio, situação, página e o candidato escolhido. Aberto pelo card, reabre Atender com outro.
 */
export function kanbanReturnState(state, context, candidateId = null) {
  const candidates = context.query?.candidates;
  return {
    ...state,
    kanbanReopen: {
      kind: context.kind === 'other' ? 'other' : 'vehicles',
      companyId: context.companyId,
      group: context.group,
      item: context.item,
      candidates: candidates
        ? { radiusKm: candidates.radiusKm, status: candidates.status, page: candidates.page }
        : null,
      candidateId,
    },
  };
}

export function saveAttendanceSession(
  response,
  context,
  returnState,
  storage = window.sessionStorage,
) {
  if (
    !validKey(response?.operationId) ||
    !validId(response.loadId) ||
    response.companyId !== context.companyId ||
    response.loadId !== context.item.loadId ||
    !response.token ||
    !['PRE_LOAD', 'LOAD'].includes(response.loadKind) ||
    response.loadKind !== context.item.type ||
    (response.mode !== undefined && response.mode !== 'OTHER')
  )
    throw new Error('Resposta de atendimento inválida. Atualize a fila.');
  const returnTo = `${context.location.pathname}${context.location.search || ''}`;
  if (!returnTo.startsWith('/kanban-cargas') || returnTo.split('?')[0] !== '/kanban-cargas')
    throw new Error('Contexto de retorno ao Kanban inválido.');
  const record = { ...response, returnTo, returnState };
  storage.setItem(`${prefix}${record.operationId}`, JSON.stringify(record));
  return record;
}

export function readAttendanceSession(
  search,
  loadId,
  companyId,
  kind,
  storage = window.sessionStorage,
) {
  const key = new URLSearchParams(search).get('tc');
  if (key === null) return { record: null, error: null };
  try {
    if (!validKey(key)) throw new Error();
    const record = JSON.parse(storage.getItem(`${prefix}${key}`));
    if (
      !record ||
      record.operationId !== key ||
      record.loadId !== Number(loadId) ||
      record.companyId !== companyId ||
      record.loadKind !== kind ||
      !record.token ||
      (record.mode !== undefined && record.mode !== 'OTHER') ||
      !(
        validId(record.selection?.vehicle?.id) ||
        // 5719: Atender com outro só pelo implemento: sem cavalo nem motorista, um implemento.
        (record.mode === 'OTHER' &&
          record.selection?.vehicle === null &&
          record.selection.driver === null &&
          record.selection.wagons?.length === 1)
      ) ||
      // Motorista nulo: o veículo não tem motorista e o usuário preenche no cadastro.
      (record.selection?.driver !== null && !validId(record.selection?.driver?.id)) ||
      !Array.isArray(record.selection.wagons) ||
      !/^\/kanban-cargas(?:\?|$)/.test(record.returnTo)
    )
      throw new Error();
    return { record, error: null };
  } catch {
    return {
      record: null,
      error:
        'O contexto de atendimento não está disponível nesta empresa ou nesta aba. Retorne ao Kanban e selecione o candidato novamente.',
    };
  }
}

export function clearAttendanceSession(record, storage = window.sessionStorage) {
  if (record) storage.removeItem(`${prefix}${record.operationId}`);
}

export function attendancePayload(record) {
  return record ? { controlTowerContext: record.token } : {};
}
